import { render } from "./SelectDate.vue?vue&type=template&id=30670e92&scoped=true"
import script from "./SelectDate.vue?vue&type=script&lang=js"
export * from "./SelectDate.vue?vue&type=script&lang=js"

import "./SelectDate.vue?vue&type=style&index=0&id=30670e92&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30670e92"]])

export default __exports__